var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsArrowForwardIosRounded({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31178 19.6838C8.10393 19.473 8 19.2234 8 18.935C8 18.6466 8.10393 18.3973 8.31178 18.1871L14.4018 12.0105L8.29099 5.81291C8.097 5.61616 8 5.37022 8 5.0751C8 4.77997 8.10393 4.52701 8.31178 4.31621C8.51963 4.1054 8.76573 4 9.05007 4C9.33441 4 9.58023 4.1054 9.78753 4.31621L16.7714 11.4203C16.8545 11.5046 16.9135 11.596 16.9484 11.6943C16.9834 11.7927 17.0005 11.8981 17 12.0105C17 12.123 16.9825 12.2284 16.9476 12.3267C16.9127 12.4251 16.8539 12.5165 16.7714 12.6008L9.76674 19.7049C9.57275 19.9016 9.33358 20 9.04924 20C8.76489 20 8.51908 19.8946 8.31178 19.6838Z",
    fill: "#E9FE53"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#E9FE53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsArrowForwardIosRounded);
export default __webpack_public_path__ + "static/media/material-symbols_arrow-forward-ios-rounded.ad2f4dd285bf3406f0777e9ec01d10f5.svg";
export { ForwardRef as ReactComponent };